import { atom } from 'jotai';
import { Project } from '../types';

export const projectAtom = atom<Project | undefined>(undefined);
